/** Aktif oda tasarımcısı aracı — `drawer-state` event detail ile aynı değerler. */
/**
 * Kept in core so the shared tool-mode helpers do not depend on the room
 * designer product. `IRoomDrawer.RoomDrawerToolMode` is declared as the same
 * union and re-exported from here.
 */
export type RoomDrawerToolMode =
  | "select"
  | "draw"
  | "window"
  | "door"
  | "resize";

export const DESIGNER_TOOL_SELECT = "select";
export const DESIGNER_TOOL_DRAW = "drawer";
export const DESIGNER_TOOL_WINDOW = "window";
export const DESIGNER_TOOL_DOOR = "door";
export const DESIGNER_TOOL_RESIZE = "resize";
export const DESIGNER_TOOL_MEASURE = "measure";

export type DesignerToolState =
  | typeof DESIGNER_TOOL_SELECT
  | typeof DESIGNER_TOOL_DRAW
  | typeof DESIGNER_TOOL_WINDOW
  | typeof DESIGNER_TOOL_DOOR
  | typeof DESIGNER_TOOL_RESIZE
  | typeof DESIGNER_TOOL_MEASURE;

export function isDrawToolState(state: string): boolean {
  return state === DESIGNER_TOOL_DRAW;
}

export function isSelectToolState(state: string): boolean {
  return state === DESIGNER_TOOL_SELECT;
}

export function isResizeToolState(state: string): boolean {
  return state === DESIGNER_TOOL_RESIZE;
}

export function isMeasureToolState(state: string): boolean {
  return state === DESIGNER_TOOL_MEASURE;
}

export function drawerToolModeFromState(
  state: string,
): RoomDrawerToolMode {
  if (isDrawToolState(state)) return "draw";
  if (state === DESIGNER_TOOL_WINDOW) return "window";
  if (state === DESIGNER_TOOL_DOOR) return "door";
  if (isResizeToolState(state)) return "resize";
  return "select";
}

export function normalizeDesignerToolState(state: string): DesignerToolState {
  if (isDrawToolState(state)) return DESIGNER_TOOL_DRAW;
  if (state === DESIGNER_TOOL_WINDOW) return DESIGNER_TOOL_WINDOW;
  if (state === DESIGNER_TOOL_DOOR) return DESIGNER_TOOL_DOOR;
  if (isResizeToolState(state)) return DESIGNER_TOOL_RESIZE;
  if (isMeasureToolState(state)) return DESIGNER_TOOL_MEASURE;
  return DESIGNER_TOOL_SELECT;
}
